export const setVisitorGeographyDetail = (state, payload) => {
    state.visitor_geography_detail = payload
    state.timings = payload.timing
    localStorage.setItem('country', payload.country)
    localStorage.setItem('timezone', payload.timezone)    
}

export const setCountryList = (state, payload) => {
    state.country_list = payload
}

export const setSalutationList = (state, payload) => {
    state.salutation_list = payload
}

export const toggleLoadingState = (state, payload) => {
    state.loadingState = payload
}

export const setScreenWidth = (state, payload) => {
    let screenWidth = parseInt(payload)
    state.screen_width = screenWidth
    
    if(screenWidth>790 && screenWidth<950) {
        state.font_sizes.f13 = '17px'
        state.font_sizes.f18 = '18px'
        state.font_sizes.f28 = '28px'
        state.font_sizes.f54 = '45px'
    } else if(screenWidth>650 && screenWidth<790) {
        state.font_sizes.f13 = '17px'
        state.font_sizes.f18 = '18px'
        state.font_sizes.f28 = '28px'
        state.font_sizes.f54 = '35px'
    } else if(screenWidth<650) {
        state.font_sizes.f13 = '17px'
        state.font_sizes.f18 = '18px'
        state.font_sizes.f28 = '22px'
        state.font_sizes.f54 = '35px'
    }
    
    /* = (width*(13/1440))+'px'
    state.font_sizes.f16 = (width*(16/1440))+'px'
    state.font_sizes.f18 = (width*(18/1440))+'px'
    state.font_sizes.f20 = (width*(20/1440))+'px'
    state.font_sizes.f22 = (width*(22/1440))+'px'
    state.font_sizes.f24 = (width*(24/1440))+'px'
    state.font_sizes.f28 = (width*(28/1440))+'px'
    state.font_sizes.f48 = (width*(48/1440))+'px'
    state.font_sizes.f50 = (width*(50/1440))+'px'
    state.font_sizes.f54 = (width*(54/1440))+'px'
    */
}

export const setFeatureListPortWidth = (state, payload) => {
    state.feature_list_port = parseInt(payload)
}

export const setSignupFormWarning = (state, payload) => {
    state.props.warning_message = payload
    state.props.warning = true
}

export const setFormSubmittedStatus = (state, payload) => {
    state.props.form_submitted = true
    state.props.form_submitted_message = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/master/mutations.js